
<template>
    <div ref="listWrap">
        <wrapper-list
                @add="paasAddPage"
                @calculate="paasCalculate"
                ref="wrapperList" >
            <Form class="list-query-wrap" slot="query" :model="queryParam" :label-width="defaultLabelWidth" ref="queryForm">
                <row class="list-query-row">
                    <FormItem label="订单号" class="list-query-item">
                        <Input  v-model="queryParam.query_LIKE_orderCode" placeholder=""
                                @on-change="queryTableDatas('param')" clearable />
                    </FormItem>
                </row>
                <row class="list-query-row">
                    <FormItem label="订单状态" class="list-query-item">
                        <ButtonGroup >
                            <Button :type="checkStatus==''?'primary':'default'" @click="selectStatus('')">全部</Button>
                            <Button :type="checkStatus=='0'?'primary':'default'" @click="selectStatus('0')">待付款</Button>
                            <Button :type="checkStatus=='1'?'primary':'default'" @click="selectStatus('1')">待发货</Button>
                            <Button :type="checkStatus=='2'?'primary':'default'" @click="selectStatus('2')">待收货</Button>
                            <Button :type="checkStatus=='3'?'primary':'default'" @click="selectStatus('3')">待评价</Button>
                            <Button :type="checkStatus=='4'?'primary':'default'" @click="selectStatus('4')">已完成</Button>
                            <Button :type="checkStatus=='-1'?'primary':'default'" @click="selectStatus('-1')">已取消</Button>
                            <Button :type="checkStatus=='-2'?'primary':'default'" @click="selectStatus('-2')">已关闭</Button>
                        </ButtonGroup>
                    </FormItem>
                </row>
            </Form>
            <Table slot="table" stripe border :height="tableHeight"
                   :data="tableData"
                   :columns="tableColumns"
                   @on-selection-change="selectTableDataChange"
                   @on-sort-change="sortTableData"
                   :no-data-text="noDataText">
            </Table>
            <Page slot="page"  :total="totalRecords"
                  show-total show-sizer
                  @on-change="changePage"
                  @on-page-size-change="changePageSize">
            </Page>
        </wrapper-list>
    </div>
</template>
<script>
    import wrapperList from "@components/paas/wrapper-list";
    import metaList from "@assets/js/list/meta-list.js";
    import EnumShow from "@components/paas/enum-show";  //如果有枚举，需要引入
    import CellBar from '@components/paas/cell-bar'
    import OrderExpand from "./order-expand.vue"; //列表内操作
    import {saveChangePrice} from '@api/order';
    export default {
        name: "list",
        mixins: [ metaList ],
        components: { wrapperList,EnumShow  ,CellBar,OrderExpand},
        data() {
            return {
                serviceUrl:"/eb/order",  //每个页面访问后台服务器的路径
                currentIdFiledName: 'id',
                queryParam:{
                    query_LIKE_orderCode:"",
                    query_LIKE_mcOrderCode:"",
                    query_LIKE_createUserName:"",
                    queryOrderBy_: 'orderTime@DESC',
                },
                checkStatus:"",
                defaultLabelWidth:200,
                tableColumns:[
                    {
                        type: 'expand',
                        width: 50,
                        render: (h, params) => {
                            return h(OrderExpand, {
                                props: {
                                    rowData: params.row
                                }
                            })
                        }
                    },
                    {
                        title: '订单号',
                        key: 'orderCode',
                        width:300,
                        render:(h, params) => {
                            let code = params.row.orderCode;
                            return h("div",[
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small'
                                    },
                                    style: {
                                        marginRight: '5px',
                                        color:'#2b85e4'
                                    },
                                    on: {
                                        click: () => {
                                            this.$router.push({'path':this.setUrlFuncId("/eb/order/orderDesc?id="+params.row.id)});
                                        }
                                    }
                                }, params.row.orderCode),
                                h('Button', {
                                    class:code+"_btn",
                                    props: {
                                        size: 'small'
                                    },
                                    on: {
                                        click: () => {
                                            this.doCopy(code);
                                        }
                                    },

                                }, "复制"),
                            ])
                        }
                    },
                    {
                        title: '买家信息',
                        key: 'buyer',
                        "width": 160,
                        render:(h,params)=>{
                            var buyer = params.row.buyer?params.row.buyer:"无";
                            return h('div',[
                                h('p', {},"买家昵称："+buyer),
                                h('p', {},"收货人："+params.row.realName)
                            ])
                        }
                    },

                    {
                        title: '收货人手机',
                        key: 'userPhone',
                        width:130,
                    },
                    {
                        title: '详细地址',
                        key: 'userAddress',
                        width:200
                    },
                    {
                        title: '数目',
                        key: 'totalNum',
                        width:60,
                    },
                    {
                        title: '金额',
                        key: 'payPrice',
                        width:180,
                        render:(h,params)=>{
                            let inputRender = h("Input",{
                                props: {
                                    value: params.row.payPrice
                                },
                                style:{
                                    width:'100px',
                                },
                                on: {
                                    'on-change': (event) => {
                                        params.row.payPrice = event.target.value
                                    }
                                }
                            });
                            let buttonRender = h('Button', {
                                    props: {
                                        size: 'small',
                                        type: 'info'
                                    },
                                    style: {
                                        marginLeft: '5px',
                                        color:'#fff'
                                    },
                                    on: {
                                        click: (event) => {
                                            this.$Modal.confirm({
                                                title: "修改待支付订单金额",
                                                content: "确定修改订单号 " + params.row.orderCode + " 的支付金额为： "+ params.row.payPrice,
                                                okText: "确定",
                                                cancelText: "取消",
                                                onOk: () => {
                                                    this.saveChangePrice(params.row.id, params.row.payPrice);
                                                },
                                                onCancel: () => {
                                                    this.$Message.info('Cancel Add Delay Modal');
                                                }
                                            });

                                        }
                                    }
                                }, "确认");
                            if (params.row.payPrice >= 20000 && params.row.status=='0'){
                                return h("div",[
                                    inputRender,
                                    buttonRender
                                ]);
                            }else{
                                return h('p',{},params.row.payPrice);
                            }
                        }
                    },
                    {
                        title: '支付方式',
                        key: 'payType',
                        width:80,
                        render:(h,params)=>{
                            return h(EnumShow,{
                                props:{
                                    enumGroupCode:'crmdict',
                                    enumCode:'payType',
                                    value:params.row.payType
                                }
                            })
                        }
                    },
                    {
                        title: '订单状态',
                        key: 'status',
                        width:80,
                        render:(h,params)=>{
                            return h(EnumShow,{
                                style: {
                                    color:'red'
                                },
                                props:{
                                    enumGroupCode:'crmdict',
                                    enumCode:'orderStatus',
                                    value:params.row.status
                                }
                            })
                        }
                    },
                    {
                        title: '支付状态',
                        key: 'paid',
                        width:80,
                        render:(h,params)=>{
                            return h(EnumShow,{
                                props:{
                                    enumGroupCode:'crmdict',
                                    enumCode:'payStatus',
                                    value:params.row.paid
                                }
                            })
                        }
                    },
                    {
                        title: '下单时间',
                        key: 'orderTime',
                        width:140,
                    },
                    {
                        title: '支付时间',
                        key: 'payTime',
                        width:140,
                    }
                ],
            }
        },
        mounted(){
        },
        methods:{
            selectStatus(status){
                this.checkStatus = status;
                if(status){
                    this.queryParam.query_EQ_status = status;
                    delete this.queryParam.query_LIKE_status;
                }else{
                    this.queryParam.query_LIKE_status = status;
                    delete this.queryParam.query_EQ_status;
                }

                this.queryTableDatas('param');
            },
            doCopy(content){
                this.$copyText(content).then(e=>{
                    this.$Message.info("复制成功");
                }, e=> {
                    this.$Message.error("复制失败");
                })
                /*let clipboard = new Clipboard("."+content+"_btn");
                clipboard.on('success', e => {
                    console.log('复制成功')
                    // 释放内存
                    clipboard.destroy()
                })
                clipboard.on('error', e => {
                    // 不支持复制
                    console.log('该浏览器不支持自动复制')
                    // 释放内存
                    clipboard.destroy()
                })*/
            },
            /**
             *
             * @param id
             * @param payPrice
             */
            saveChangePrice(id,payPrice){
                let param = {};
                param.id = id;
                param.payPrice = payPrice;
                saveChangePrice(param).then(res=>{
                    if(res.code == 200){
                        this.$Message.info("更改价格成功")
                    }
                })
            }
        }
    }
</script>
